import { createSlice } from "@reduxjs/toolkit";

interface LoadingProps {
  isLoading: boolean;
}

const initialState = {
  isLoading: false,
} as LoadingProps;

export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setIsLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
